import { useMemo } from "react";
import { Select } from "@design-system/Select/Select";
import {
  useAutotaskConnectionQuery,
  useAutotaskCompaniesQuery,
} from "@graphql/integrations/integrations.g";

type Props = {
  value?: string;
  onChange: (value: string) => void;
};

export const AutotaskCompanySelect = ({ value, onChange }: Props) => {
  const connectionQuery = useAutotaskConnectionQuery();
  const companiesQuery = useAutotaskCompaniesQuery(
    {},
    {
      enabled: !!connectionQuery.data?.autotaskConnection?.isActive,
    }
  );

  const isActive = connectionQuery.data?.autotaskConnection?.isActive;

  const options = useMemo(() => {
    if (!companiesQuery.data?.autotaskCompanies) return [];
    return companiesQuery.data.autotaskCompanies.map((c) => ({
      id: c?.id || "",
      label: c?.companyName || "Unknown",
    }));
  }, [companiesQuery.data]);

  if (!isActive) return null;

  return (
    <Select
      value={value || ""}
      onChange={(val) => onChange(val as string)}
      options={options}
    />
  );
};
